// prod
export const HOST = "https://www.aizu-miraizu.com";

// dev
// export const HOST = 'http://3.143.251.158'

// local
// export const HOST = "http://192.168.11.5:5000";
